import { Component, ElementRef, ViewChild } from '@angular/core';
import { WIZ_EVENT_TYPE} from '@wizeoo/akm-core-lib';
import {
  FilterComponent,
  WizBasePopUp,
  WizCheckbox,
  WizDatasource,
  WizList,
  WizPopUp,
  WizVgroup,
  WizEventManager, WizEvent, WizTranslationManager
} from '@wizeoo/akm-component-lib';
import { WidgetConfigurationObj, WidgetConfigurationItemObj } from '@wizeoo/akm-message-lib';
import { EM_ACTION } from '@wizeoo/akm-compute-lib';
import { cloneDeep } from 'lodash-es';

import { PivotField } from '../../../../manager/baselines/pivot-field.obj';
import { IFreedataWidget } from '../../../../manager/widgets/i-widget';
import { WIDGET_KIND } from '../../../../model/enums';
import { ViewData } from '../../../../model/view.data';
import { FreedataArgsVO } from '../../../../vo/core/freedataargs.vo';
import { Model } from '../../../../model/model';
import { FreedataEditItemRenderer } from './freedata-edit-item.renderer';
import { FreeDataVO } from '../../../../vo/core/freedata.vo';
import { FreedataValueVO } from '../../../../vo/core/freedatavalue.vo';
import { GridsterWidgetItem } from '../../../../vo/workingzone/gridster-widget-item';
import { gridsterItemEvent } from '../../form/generic/form-widget.gridster.component';

@Component({
  // popUp d'édition du grid en mode flat : gestion des emplacements de champs et rendu
  selector: 'freedata-form-settings-pop',
  templateUrl: './freedata-form-settings.pop.html',
})
export class FreedataFormSettingsPop extends WizBasePopUp {
  // liste des champs et mesures disponibles
  @ViewChild('freeList', { read: WizList }) freeList: WizList;
  /** le composant de filtre principal */
  @ViewChild('mainFilter', { read: FilterComponent })
  mainFilter: FilterComponent;
  // zone globale des listes
  @ViewChild('vgDetailZone', { read: WizVgroup, static: false })
  vgDetailZone: WizVgroup;

  @ViewChild('cbShowDeleteCol', { read: WizCheckbox })  cbShowDeleteCol: WizCheckbox; // cb d'affichage de la colonne delete
  @ViewChild('cbShowSelectCol', { read: WizCheckbox })  cbShowSelectCol: WizCheckbox; // cb d'affichage de la colonne select
  @ViewChild('cbSelectUnique', { read: WizCheckbox }) cbSelectUnique: WizCheckbox; // cb sélection unique

  // dimensions demandées
  public static width: string = '1000px';
  public static height: string = 'calc(100% - 81px)';


  /** Renderer de la liste */
  public renderer: any = FreedataEditItemRenderer;

  public dataSource: WizDatasource<PivotField> = null; // DS des champs disponibles (au step)

  protected context: WidgetConfigurationObj; // la configuration
  protected updateCallback: Function; // la callback pour retour et traitement dans le pivotComponent
  
  public get widget(): IFreedataWidget {
    return this.datas;
  }

  public get model(): Model {
    return this.widget?.model;
  }


  protected doSaveFlag: boolean = true; // marqueur de validation des modifs (false sur cancel)
  protected fieldPop: WizPopUp; // la popUp d'édition des champs
  public popUpMode: WIDGET_KIND = WIDGET_KIND.GRID; // le mode de cette pop, pour alimenter les PKD

  // Le freeData fake utilisé juste pour la configuration
  fakeFreeDataValue: FreedataValueVO;

  /** autoriser la zone de drop de filtres et la col de sélection */
  public get useGridFunctions(): boolean {
    return this.widget?.widgetKind === WIDGET_KIND.FD_GRID;
  }

  constructor(public elementRef: ElementRef) {
    super();
  }

  show(): void {

    this.context = cloneDeep(this.widget.context); 
    this.updateCallback = this.widget.backFromSettingsPop.bind(this.widget);


    const fd: FreeDataVO = this.model.freedataEngine.getFreeData(this.context.fdk.split(ViewData.CONTEXT_SEPARATOR)[0]);// todo gérer le level
    this.fakeFreeDataValue = this.model.freedataEngine.createFreeDataValue(fd, null);

    const filter = []; // alimentation du filtre de la DS principale

    this.mainFilter.configure(['code', 'labelOrDefaultLabel'], null, Array.from(filter)).build();

    const parts: string[] = this.context.fdk.split(ViewData.CONTEXT_SEPARATOR); // on split sur #
    const args: FreedataArgsVO[] = this.model.freedataEngine.getArgsFromFD(parts[0]);
    const fieldsMap: Map<string, FreedataArgsVO> = new Map(args.map(item => [item.code, item]));

    const dataDS: PivotField[] = [];
    args.forEach((fda: FreedataArgsVO) => {
      const wcio: WidgetConfigurationItemObj = this.model.widgetEngine.newWcio(this.context.fdk, 0);
      wcio.fdvf = fda.code;
      dataDS.push(new PivotField(this.widget, wcio, null, fda));
    });


    // ajout du fake pour mettre un texte libre
    let wcio: WidgetConfigurationItemObj = this.model.widgetEngine.newWcio(this.context.fdk, 0);
    wcio.fdvf = ViewData.FORM_HTML;
    wcio.lbl = null; // sinon va injecter ça dans le contenu WizTranslationManager.getInstance().translateKey('$.common.free.content.$');
    const fakeLabel: PivotField = new PivotField(this.widget, wcio, null, null);
    fakeLabel.order = -4;
    dataDS.push(fakeLabel);

    // ajout du fake pour mettre une image
    wcio = this.model.widgetEngine.newWcio(this.context.fdk, 0);
    wcio.fdvf = ViewData.FORM_IMAGE;
    wcio.lbl = WizTranslationManager.getInstance().translateKey('$.common.free.image.$');
    const fakeImg: PivotField = new PivotField(this.widget, wcio, null, null);
    fakeImg.order = -3;
    dataDS.push(fakeImg);

    // ajout du fake pour mettre un bouton connect
    wcio = this.model.widgetEngine.newWcio(this.context.fdk, 0);
    wcio.fdvf = ViewData.FORM_ACTION;
    wcio.lbl = WizTranslationManager.getInstance().translateKey('$.common.free.action.$');
    const fakeAction: PivotField = new PivotField(this.widget, wcio, null, null);
    fakeImg.order = -2;
    dataDS.push(fakeAction);

    // ajout du fake pour mettre une zone de drop
    wcio = this.model.widgetEngine.newWcio(this.context.fdk, 0);
    wcio.fdvf = ViewData.FORM_DROP;
    wcio.lbl = WizTranslationManager.getInstance().translateKey('$.common.free.drop.$');
    const fakeDrop: PivotField = new PivotField(this.widget, wcio, null, null);
    fakeImg.order = -1;
    dataDS.push(fakeDrop);

    // ajout du fake pour mettre une zone 
    wcio = this.model.widgetEngine.newWcio(this.context.fdk, 0);
    wcio.fdvf = ViewData.FORM_ZONE;
    wcio.lbl = WizTranslationManager.getInstance().translateKey('$.common.free.zone.$');
    const fakeZone: PivotField = new PivotField(this.widget, wcio, null, null);
    fakeZone.order = -5;
    dataDS.push(fakeZone);



    this.dataSource = new WizDatasource<PivotField>(dataDS)
    .setItemCodeField('code')
    .setSelectionMode('none')
    .setSortFields([{ property: 'order', way: 'asc', numeric: true },{ property: 'labelOrDefaultLabel', way: 'asc', numeric: false }]) //  
    .setFilter(this.filterFunc.bind(this))
    .build();

    this.widgets = [];
    if (this.context.ff) {
      this.context.ff.forEach((wcio: WidgetConfigurationItemObj) => {
        // console.log('ffsetting', obj, obj.subField);
        const matrix: FreedataArgsVO = fieldsMap.get(wcio.fdvf); // va servir de matrice, c'est la structure
    
        if (!!matrix) {
          // mais on peut en faire plusieurs
          const result: GridsterWidgetItem = new GridsterWidgetItem(wcio, new PivotField(this.widget, wcio, null, matrix));
          
          this.widgets.push(result);
        } else if(ViewData.isFreeField(wcio.fdvf)) {
          const result: GridsterWidgetItem = new GridsterWidgetItem(wcio, new PivotField(this.widget, wcio, null, matrix));
          
          this.widgets.push(result);
        }
      });      
    }   
    this.addListeners();
  }

  /** mise en place des écouteurs */
  public addListeners(): void {
    WizEventManager.addListener(this, this.mainFilter, WIZ_EVENT_TYPE.FILTER, this.doFilter); // ecouteur sur le filtre de la DS principale
    // WizEventManager.addListener(this, this.elementRef, ALK_EVENT_TYPE.PIVOT_CONFIGURE_FIELD, this.showConfPop); // demande de conf d'un champ
  }

  /** icone de suppression globale */
  public onDeleteClick(): void {
    this.widgets = [];
  }


  /** validation du contenu */
  public doValid(): void {
    this.hide();
  }

  /** annulation des modifs */
  public doCancel(): void {
    this.doSaveFlag = false;
    this.hide();
  }

  widgets: GridsterWidgetItem[] = [];

  /** modification du context pour retour sur la base des params */
  private updateContext(): void {
    this.context.r = [];
    this.context.f = [];

    this.context.ff = this.widgets.map((obj) => obj.source);

    this.context.shd = this.cbShowDeleteCol.wizChecked; // affichage du delete
    this.context.shs = this.cbShowSelectCol.wizChecked; // affichage du select
    this.context.shsu = this.cbSelectUnique.wizChecked; // affichage du select unique
  }

  public onHide() {
    if (this.doSaveFlag) {
      if (!!this.updateCallback) {
        this.updateContext();
        this.updateCallback(this.context);
      }
    }
  }

  /* ##############################################################################
                    filtre et rendu de la DS principale
     ############################################################################## */

  /**
   * modification du filtre
   * @param e WizEvent
   */
  protected doFilter(e: WizEvent): void {
    this.dataSource.refresh();
  }

  // filterFunc de la collection principale
  protected filterFunc(item: any): boolean {
    return this.mainFilter.checkVisible(item);
  }

  onWidgetsChanged(event: gridsterItemEvent) {
    // console.log('onWidgetsChanged',event, this.widgets);
    switch(event.action) {
      case EM_ACTION.CREATE:
        this.widgets = [event.item, ...this.widgets];
        break;
      case EM_ACTION.UPDATE:
        // console.log('onWidgetsChanged rien a faire');
        event.item.updateCoords(); // mise à jour des coords
        break;
      case EM_ACTION.DELETE:
        this.widgets.splice(this.widgets.indexOf(event.item), 1);
        break;     
    }
  }

  public get freezoneicon(): string {
    // let res: string = 'reduce';
    let res: string;
    if(!this.fullSize) {
      res = 'creation';
    } else {
      res = 'reduce';
    }
    // console.log("TODO selon value (reduce / creation)", this._data?.wcio?.pgrp, res);
    return res;
  }
  public fullSize: boolean = false;
  public moreLess():void {
    if(!this.fullSize) {
      (this.widget.settingsPopInstance as WizPopUp).dialogRef.updateSize('100vw',FreedataFormSettingsPop.height);
    } else {
      (this.widget.settingsPopInstance as WizPopUp).dialogRef.updateSize(FreedataFormSettingsPop.width ,FreedataFormSettingsPop.height);
    }
    this.fullSize = !this.fullSize;
  }

}
